// extracted by mini-css-extract-plugin
module.exports = {"content":"TagLine_content__q1Clo","text":"TagLine_text__jFYGn","button":"TagLine_button__8qTBZ","cover":"TagLine_cover__dvbv2"};